/* eslint-disable @typescript-eslint/no-explicit-any */
import { NewsShop } from "./NewsStepTwoShop";

/* เก็บข้อมูลที่กรอกไว้ที่ sessionStorage เพื่อให้ refresh หน้าแล้วยังอยู่ step เดิมและค่าไม่หาย
   (ข้อมูลจะถูกล้างเองเมื่อปิดแท็บ) */
const DRAFT_KEY_PREFIX = "sellcoda:news-draft";

export interface NewsDraft {
  step: number;
  status?: string;
  topic: string;
  content: string;
  imgUrl?: string;
  imgFile?: { name?: string; type?: string };
  imgSkipped?: boolean;
  shops: NewsShop[];
  shopsLoaded?: boolean;
  values: {
    topic?: string;
    type?: string;
    app?: string[];
    startDate?: string;
    startTime?: string;
  };
  savedAt: number;
}

export const getNewsDraftKey = (isEdit: boolean, id?: string) =>
  `${DRAFT_KEY_PREFIX}:${isEdit ? `edit:${id}` : "create"}`;

export const loadNewsDraft = (key: string): NewsDraft | undefined => {
  try {
    const raw = sessionStorage.getItem(key);
    return raw ? (JSON.parse(raw) as NewsDraft) : undefined;
  } catch (e) {
    console.log("load news draft error", e);
    return undefined;
  }
};

export const saveNewsDraft = (key: string, draft: NewsDraft) => {
  try {
    sessionStorage.setItem(key, JSON.stringify(draft));
  } catch (e) {
    /* sessionStorage เต็ม (ส่วนใหญ่มาจากรูป base64) จึงเก็บใหม่แบบไม่เอารูป
       เพื่อให้ข้อมูลส่วนที่เหลือยังถูกจำไว้ */
    try {
      sessionStorage.setItem(
        key,
        JSON.stringify({ ...draft, imgUrl: undefined, imgFile: undefined, imgSkipped: true }),
      );
    } catch (err) {
      console.log("save news draft error", err);
    }
  }
};

export const clearNewsDraft = (key: string) => {
  try {
    sessionStorage.removeItem(key);
  } catch (e) {
    console.log("clear news draft error", e);
  }
};

/* มี draft ที่ "กรอกอะไรไปแล้วจริง ๆ" หรือยัง (กันขึ้นข้อความกู้คืนทั้งที่ยังไม่ได้กรอก) */
export const hasDraftData = (draft?: NewsDraft) =>
  !!draft &&
  (draft.step > 0 ||
    !!draft.values?.topic ||
    !!draft.imgUrl ||
    !!draft.imgSkipped ||
    !!draft.status ||
    (!!draft.content && draft.content !== "-") ||
    (draft.shops?.length || 0) > 0);

/* แปลง base64 ที่เก็บไว้กลับเป็นไฟล์ เพื่อให้ตอนบันทึกยังอัปโหลดรูปเดิมได้ */
export const dataUrlToFile = (dataUrl?: string, name?: string, type?: string) => {
  if (!dataUrl || !dataUrl.startsWith("data:")) return undefined;
  try {
    const [meta, base64] = dataUrl.split(",");
    const mime = type || meta.match(/:(.*?);/)?.[1] || "image/jpeg";
    const binary = atob(base64);
    const buffer = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i += 1) buffer[i] = binary.charCodeAt(i);
    return new File([buffer], name || `news-image.${mime.split("/")[1] || "jpg"}`, { type: mime });
  } catch (e) {
    console.log("restore draft image error", e);
    return undefined;
  }
};
